import { useEffect, useCallback } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { triggerSignIn } from '@fiverr-private/identification_triggers';
import { logger } from '@fiverr-private/obs';

interface UseSignInModalForGuestsReturn {
    triggerSignInModal: () => Promise<void>;
}

export const useSignInModalForGuests = (): UseSignInModalForGuestsReturn => {
    const { userId } = getContext();

    const triggerSignInModal = useCallback(async () => {
        try {
            await triggerSignIn({
                modalOptions: {
                    isSticky: true,
                    skipQuestionnaire: true,
                    afterSigningSuccess: ({ redirectUrl }) => {
                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                        }
                    },
                },
            });
        } catch (error) {
            logger.error(error as Error, {
                description: 'Failed to trigger sign in modal',
            });
        }
    }, []);

    useEffect(() => {
        if (!userId) {
            triggerSignInModal();
        }
    }, [userId, triggerSignInModal]);

    return { triggerSignInModal };
};
